/* eslint-disable max-len */

import * as R from 'ramda';

export default function NotificationsController(
  $rootScope,
  $scope,
  $q,
  loaderService,
  userService,
  vmDataService,
  vmSharedModelService,
  sendNotificationsDialog,
  ssDialogService,
) {
  const vm = this;
  vm.serviceId = 1;

  vm.appIsLoaded = false;
  vm.loaderService = loaderService;

  vm.isExpanded = false;

  vm.handleShowNotifications = _handleShowNotifications;
  vm.handleShowVendorList = _handleShowVendorList;
  vm.handleShowVendor = _handleShowVendor;
  vm.handleShowProduct = _handleShowProduct;
  vm.handleOpenNotificationsDialog = _handleOpenNotificationsDialog

  vm.contractList = {};
  vm.riskAssessmentList = {};
  vm.controlReviewList = {};
  vm.certificateOfInsuranceList = {};
  vm.systemAndOrganizationControlList = {};

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
  }
  function _initEventListeners() {
    $scope.$on('refreshVMVendor', () => {
      _refreshNotifications(true);
    });

    $scope.$on('vmNotificationsLoaded', (event, data) => {
      vm.notifications = data.notifications;
      vm.lastBoardReviewDate = data.lastBoardReviewDate;
      _initNotificationData();
      vm.appIsLoaded = true;
    });

    $scope.$on('settingsUpdated', () => { _refreshLastBoardReviewDate(); });
  }

  function _refreshNotifications(forceRefresh) {
    loaderService.showViewLoader = true;
    return vmSharedModelService.initVendorManagement(vm.serviceId).then((initVendorManagementResponse) => {
      loaderService.showViewLoader = false;
      if (initVendorManagementResponse.data.notificationUsers !== null) { 
        vm.notifications = initVendorManagementResponse.data.notificationUsers.result;
      }
      if (initVendorManagementResponse.data.settingsDefaults.result.length > 0) {
        vm.lastBoardReviewDate = initVendorManagementResponse.data.settingsDefaults.result[0].lastBoardReviewDate;
      }
      _initNotificationData();
    });
  }

  function _refreshLastBoardReviewDate() {
    loaderService.showViewLoader = true;
    return vmSharedModelService.getSettings(true).then((settings) => {
      loaderService.showViewLoader = false;
      vm.lastBoardReviewDate = settings.lastBoardReviewDate;
    });
  }

  function _initNotificationData() {
    /** Board Reviews */
    const partitionedNotifications = R.partition(
      R.propEq('type', 'BoardReview'),
      vm.notifications
    );

    // if (partitionedNotifications[0] && partitionedNotifications[0][0]) {
    //   vm.lastBoardReviewDate = partitionedNotifications[0][0].dueDate;
    // }

    const allAlerts = partitionedNotifications[1];
    const alerts = R.filter(
      R.propEq('component', 'Vendor Management'), allAlerts
    );
    vm.alertBubbleCount = alerts.length;

    /** Contracts */
    vm.contractAlerts = R.filter(
      R.propEq('qualifier', 'ContractEnd'), alerts
    );

    const partitionedContractAlerts = R.partition(
      R.propEq('type', 'Product AutoRenew'), vm.contractAlerts
    );

    vm.autoRenewContractAlerts = partitionedContractAlerts[0];
    const partitionedAutoRenewContractAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.autoRenewContractAlerts
    );

    vm.expiredAutoRenewContractAlerts = partitionedAutoRenewContractAlerts[0];
    vm.expiredAutoRenewContractCount = vm.expiredAutoRenewContractAlerts.length;
    vm.contractsRenewExpiredVendors = [];
    _extractVendorsAndProducts(vm.contractsRenewExpiredVendors, vm.expiredAutoRenewContractAlerts);

    vm.dueAutoRenewContractAlerts = partitionedAutoRenewContractAlerts[1];
    vm.dueAutoRenewContractCount = vm.dueAutoRenewContractAlerts.length;
    vm.contractsRenewingVendor30 = [];
    _extractVendorsAndProducts(vm.contractsRenewingVendor30, vm.dueAutoRenewContractAlerts);
    if(vm.dueAutoRenewContractAlerts.length > 0){
      vm.contractList['Contracts approaching auto-renewal notification date'] = vm.dueAutoRenewContractAlerts
    }

    vm.manualRenewContractAlerts = partitionedContractAlerts[1];
    vm.manualRenewContractCount = vm.manualRenewContractAlerts.length;

    const partitionedManualRenewContractAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.manualRenewContractAlerts
    );

    vm.expiredManualRenewContractAlerts = partitionedManualRenewContractAlerts[0];
    vm.expiredManualRenewContractCount = vm.expiredManualRenewContractAlerts.length;
    vm.contractsExpiredVendors = [];
    _extractVendorsAndProducts(vm.contractsExpiredVendors, vm.expiredManualRenewContractAlerts);

    vm.dueManualRenewContractAlerts = partitionedManualRenewContractAlerts[1];
    vm.dueManualRenewContractCount = vm.dueManualRenewContractAlerts.length;
    vm.contractsExpiringVendor30 = [];

    _extractVendorsAndProducts(vm.contractsExpiringVendor30, vm.dueManualRenewContractAlerts);

    if(vm.expiredManualRenewContractAlerts.length > 0){
      vm.contractList['Contracts expired'] = vm.expiredManualRenewContractAlerts;
    }

     if(vm.expiredAutoRenewContractAlerts.length > 0){
      vm.contractList['Contracts auto-renewal notification date has passed'] = vm.expiredAutoRenewContractAlerts
    }

     if(vm.dueManualRenewContractAlerts.length > 0){
      vm.contractList['Contracts will expire'] = vm.dueManualRenewContractAlerts;
    }

    if(vm.dueAutoRenewContractAlerts.length > 0){
      vm.contractList['Contracts approaching auto-renewal notification date'] = vm.dueAutoRenewContractAlerts
    }

    /** Risk Assessments */
    vm.riskAssessmentAlerts = R.filter(
      R.propEq('type', 'Risk Assessment'), alerts
    );

    const partitionedRiskAssessmentAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.riskAssessmentAlerts
    );

    vm.expiredRiskAssessmentAlerts = partitionedRiskAssessmentAlerts[0];
    vm.expiredRiskAssessmentCount = vm.expiredRiskAssessmentAlerts.length;
    vm.riskAssessmentOverdueVendors = [];
    _extractVendorsAndProducts(vm.riskAssessmentOverdueVendors, vm.expiredRiskAssessmentAlerts);

    const partitionedRiskAssessmentAlerts1 = R.partition(
      R.propEq('level', 'Upcoming'), partitionedRiskAssessmentAlerts[1]
    );

    vm.dueRiskAssessmentAlerts = partitionedRiskAssessmentAlerts1[0];
    vm.dueRiskAssessmentCount = vm.dueRiskAssessmentAlerts.length;
    vm.riskAssessmentUpcomingVendors = [];
    _extractVendorsAndProducts(vm.riskAssessmentUpcomingVendors, vm.dueRiskAssessmentAlerts);  

    vm.notStartedRiskAssessmentAlerts = partitionedRiskAssessmentAlerts1[1];
    vm.notStartedRiskAssessmentCount = vm.notStartedRiskAssessmentAlerts.length;
    vm.riskAssessmentNotStartedVendors = [];
    _extractVendorsAndProducts(vm.riskAssessmentNotStartedVendors, vm.notStartedRiskAssessmentAlerts);

    if(vm.notStartedRiskAssessmentAlerts.length > 0){
      vm.riskAssessmentList['Risk Assessments not started'] = vm.notStartedRiskAssessmentAlerts;
    }

    if(vm.dueRiskAssessmentAlerts.length > 0){
      vm.riskAssessmentList['Risk Assessments upcoming'] = vm.dueRiskAssessmentAlerts;
    }

    if(vm.expiredRiskAssessmentAlerts.length > 0){
      vm.riskAssessmentList['Risk Assessments overdue'] = vm.expiredRiskAssessmentAlerts;
    }

    /** Control Reviews */
    vm.controlReviewAlerts = R.filter(
      R.propEq('type', 'Control Review'), alerts
    );

    const partitionedControlReviewAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.controlReviewAlerts
    );

    vm.expiredControlReviewAlerts = partitionedControlReviewAlerts[0];
    vm.expiredControlReviewCount = vm.expiredControlReviewAlerts.length;
    vm.controlReviewOverdueVendors = [];
    _extractVendorsAndProducts(vm.controlReviewOverdueVendors, vm.expiredControlReviewAlerts);

    const partitionedControlReviewAlerts1 = R.partition(
      R.propEq('level', 'Upcoming'), partitionedControlReviewAlerts[1]
    );

    vm.dueControlReviewAlerts = partitionedControlReviewAlerts1[0];
    vm.dueControlReviewCount = vm.dueControlReviewAlerts.length;
    vm.controlReviewUpcomingVendors = [];
    _extractVendorsAndProducts(vm.controlReviewUpcomingVendors, vm.dueControlReviewAlerts);

    const partitionedControlReviewAlerts2 = R.partition(
      R.propEq('level', 'NeverStarted'), partitionedControlReviewAlerts1[1]
    );

    vm.notStartedControlReviewAlerts = partitionedControlReviewAlerts2[0];
    vm.notStartedControlReviewCount = vm.notStartedControlReviewAlerts.length;
    vm.controlReviewNotStartedVendors = [];
    _extractVendorsAndProducts(vm.controlReviewNotStartedVendors, vm.notStartedControlReviewAlerts);
   


    vm.notCompletedControlReviewAlerts = partitionedControlReviewAlerts2[1];
    vm.notCompletedControlReviewCount = vm.notCompletedControlReviewAlerts.length;
    vm.controlReviewNotCompletedVendors = [];
    _extractVendorsAndProducts(vm.controlReviewNotCompletedVendors, vm.notCompletedControlReviewAlerts);

    if(vm.notStartedControlReviewAlerts.length > 0){
      vm.controlReviewList['Control Reviews never completed'] = vm.notStartedControlReviewAlerts;
    }

    if(vm.notCompletedControlReviewAlerts.length > 0){
      vm.controlReviewList['Control Reviews in progress'] = vm.notCompletedControlReviewAlerts;
    }

    if(vm.dueControlReviewAlerts.length > 0){
      vm.controlReviewList['Control Reviews upcoming'] = vm.dueControlReviewAlerts;
    }

     if(vm.expiredControlReviewAlerts.length > 0){
      vm.controlReviewList['Control Reviews overdue'] = vm.expiredControlReviewAlerts;
    }

    /** Certificates of Insurance */
    vm.certificateOfInsuranceAlerts = R.filter(
      R.propEq('type', 'Certificate of Insurance'), alerts
    );

    const partitionedCertificateOfInsuranceAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.certificateOfInsuranceAlerts
    );

    vm.expiredCertificateOfInsuranceAlerts = partitionedCertificateOfInsuranceAlerts[0];
    vm.expiredCertificateOfInsuranceCount = vm.expiredCertificateOfInsuranceAlerts.length;
    vm.certificateOfInsuranceOverdueVendors = [];
    _extractVendorsAndProducts(vm.certificateOfInsuranceOverdueVendors, vm.expiredCertificateOfInsuranceAlerts);

    const partitionedCertificateOfInsuranceAlerts1 = R.partition(
      R.propEq('level', 'Upcoming'), partitionedCertificateOfInsuranceAlerts[1]
    );

    vm.dueCertificateOfInsuranceAlerts = partitionedCertificateOfInsuranceAlerts1[0];
    vm.dueCertificateOfInsuranceCount = vm.dueCertificateOfInsuranceAlerts.length;
    vm.certificateOfInsuranceUpcomingVendors = [];
    _extractVendorsAndProducts(vm.certificateOfInsuranceUpcomingVendors, vm.dueCertificateOfInsuranceAlerts);

    if(vm.dueCertificateOfInsuranceAlerts.length > 0){
      vm.certificateOfInsuranceList['COIs upcoming'] = vm.dueCertificateOfInsuranceAlerts;
    }

    if(vm.expiredCertificateOfInsuranceAlerts.length > 0){
      vm.certificateOfInsuranceList['COIs overdue'] = vm.expiredCertificateOfInsuranceAlerts;
    }

    /** System and Organization Controls */
    vm.systemAndOrganizationControlsAlerts = R.filter(
      R.propEq('type', 'System and Organization Controls'), alerts
    );

    const partitionedSystemAndOrganizationControlsAlerts = R.partition(
      R.propEq('level', 'Expired'), vm.systemAndOrganizationControlsAlerts
    );

    vm.expiredSystemAndOrganizationControlsAlerts = partitionedSystemAndOrganizationControlsAlerts[0];
    vm.expiredSystemAndOrganizationControlsCount = vm.expiredSystemAndOrganizationControlsAlerts.length;
    vm.systemAndOrganizationControlsOverdueVendors = [];
    _extractVendorsAndProducts(vm.systemAndOrganizationControlsOverdueVendors, vm.expiredSystemAndOrganizationControlsAlerts);   

    const partitionedSystemAndOrganizationControlsAlerts1 = R.partition(
      R.propEq('level', 'Upcoming'), partitionedSystemAndOrganizationControlsAlerts[1]
    );

    vm.dueSystemAndOrganizationControlsAlerts = partitionedSystemAndOrganizationControlsAlerts1[0];
    vm.dueSystemAndOrganizationControlsCount = vm.dueSystemAndOrganizationControlsAlerts.length;
    vm.systemAndOrganizationControlsUpcomingVendors = [];
    _extractVendorsAndProducts(vm.systemAndOrganizationControlsUpcomingVendors, vm.dueSystemAndOrganizationControlsAlerts);

    if(vm.dueSystemAndOrganizationControlsAlerts.length > 0){
      vm.systemAndOrganizationControlList['SOCs upcoming'] = vm.dueSystemAndOrganizationControlsAlerts;
    }

     if(vm.expiredSystemAndOrganizationControlsAlerts.length > 0){
      vm.systemAndOrganizationControlList['SOCs overdue'] = vm.expiredSystemAndOrganizationControlsAlerts;
    }
  }

  function _extractVendorsAndProducts(vendorsCollection, alerts) {
    R.forEach(
      (alert) => {
        let vendor = R.find(R.propEq('vendorId', alert.parentId), vendorsCollection);

        if (!vendor) {
          vendor = {
            vendorId: alert.parentId,
            name: alert.parentTitle,
            products: [],
          };
          vendorsCollection.push(vendor);
        }

        const product = {
          vendorId: alert.parentId,
          productId: alert.Id,
          name: alert.title,
          dueDate: alert.dueDate,
          thresholdDate: alert.thresholdDate,
        };

        vendor.products.push(product);
      },
      alerts
    );
  }

  function _buildContract(alerts, type) {
    contractList[type] = alerts
  }

  // Open/Close
  function _handleShowNotifications() {
    vm.shownVendorList = null;
    vm.alertBubbleCount = 0;
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleShowVendorList(section) {
    vm.shownVendorList = vm.shownVendorList === section
      ? null
      : section;
  }

  function _handleShowVendor(vendor) {
    vmSharedModelService.filters.searchText = vendor.name;
    $rootScope.$broadcast('filterVendors');
    vm.isExpanded = false;
    // vendorManagementNavigationService.scrollToVendor(vendor.vendorId).then(() => {
    //   vendorManagementNavigationService.expandVendor(vendor.vendorId);
    // });
  }

  function _handleShowProduct(product) {
    vmSharedModelService.filters.searchText = product.name;
    $rootScope.$broadcast('filterVendors');
    vm.isExpanded = false;
    // vendorManagementNavigationService.scrollToVendor(product.vendorId).then(() => {
    //   vendorManagementNavigationService.expandVendor(product.vendorId);
    //   vendorManagementNavigationService.scrollToProduct(product.productId).then(() => {
    //     // vendorManagementNavigationService.expandProduct(product.vendorId, product.productId);
    //   });
    // });
  }

  function _handleOpenNotificationsDialog($event, type) {
    vm.isExpanded = false;
    let _alertList = {}
    switch (type) {
      case 'contract':
        _alertList = structuredClone(vm.contractList);
        break;
      case 'riskAssessment':
        _alertList = structuredClone(vm.riskAssessmentList);
        break;
      case 'controlReview':
        _alertList = structuredClone(vm.controlReviewList);
        break;
      case 'certificateOfInsurance':
        _alertList = structuredClone(vm.certificateOfInsuranceList);
        break;
      case 'systemAndOrganizationControl':
        _alertList = structuredClone(vm.systemAndOrganizationControlList);
        break;
      default:
        _alertList = {};
    }
    ssDialogService.dialogs.vendorManagement.sendRemindersDialog = ssDialogService.alert(
      sendNotificationsDialog.getOptions($event, {
        alertList: _alertList
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.sendRemindersDialog);
  }
}

NotificationsController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'loaderService',
  'userService',
  'vmDataService',
  'vmSharedModelService',
  'sendNotificationsDialog',
  'ssDialogService',
];
